// Reusable Vimeo video card with colored top border + title/description
import { useState } from "react";

export default function VideoCard({
  title,
  description,
  vimeoId,
  accent = "#e07818",
  badge,
  duration,
  testid,
  posterUrl,
}) {
  const [posterVisible, setPosterVisible] = useState(true);
  const [fading, setFading] = useState(false);

  const handleLoad = () => {
    setTimeout(() => {
      setFading(true);
      setTimeout(() => setPosterVisible(false), 1000);
    }, 800);
  };

  return (
    <article
      data-testid={testid}
      className="bg-[#f9f5ef] rounded-[18px] overflow-hidden shadow-[0_8px_24px_-12px_rgba(46,40,32,0.18)] transition-transform hover:-translate-y-1"
      style={{ borderTop: `2px solid ${accent}` }}
    >
      <div className="w-full aspect-video bg-black relative">
        <iframe
          src={`https://player.vimeo.com/video/${vimeoId}?title=0&byline=0&portrait=0`}
          title={title}
          className="absolute inset-0 w-full h-full"
          frameBorder="0"
          allow="autoplay; fullscreen; picture-in-picture"
          allowFullScreen
          onLoad={handleLoad}
          data-testid={`${testid}-iframe`}
        />
        {posterUrl && posterVisible && (
          <div
            style={{
              position: "absolute",
              inset: 0,
              backgroundImage: `url(${posterUrl})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              transition: "opacity 1s ease",
              opacity: fading ? 0 : 1,
              zIndex: 2,
              pointerEvents: "none",
            }}
          />
        )}
      </div>
      <div className="p-5">
        <div className="flex items-start justify-between gap-3">
          <h3 className="font-serif-display text-2xl text-[#2e2820] leading-tight">
            {title}
          </h3>
          {badge && (
            <span
              className="font-body text-[10px] uppercase tracking-[0.18em] px-2.5 py-1 rounded-full"
              style={{ background: `${accent}1a`, color: accent }}
            >
              {badge}
            </span>
          )}
        </div>
        {duration && (
          <p className="font-body text-xs text-[#7a6f65] mt-1 tracking-wide">
            {duration}
          </p>
        )}
        <p className="font-body text-sm text-[#7a6f65] leading-relaxed mt-3">
          {description}
        </p>
      </div>
    </article>
  );
}